import { render, staticRenderFns } from "./echarts_xueli.vue?vue&type=template&id=46f51c9f&scoped=true&"
import script from "./echarts_xueli.vue?vue&type=script&lang=js&"
export * from "./echarts_xueli.vue?vue&type=script&lang=js&"
import style0 from "./echarts_xueli.vue?vue&type=style&index=0&id=46f51c9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f51c9f",
  null
  
)

export default component.exports